import React, { useEffect } from "react";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";

import { RiUserSettingsLine } from "react-icons/ri";
import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";
import { EditMembershipDialog } from "./EditMembershipsDialog";
import { CreateMembershipDialog } from "./CreateMembershipDialog";
import { getOrgByEmail } from "../../api/user";
import { useDispatch } from "react-redux";
import { updateUser } from "../../store/mainReducer";
import { ICONS } from "../../utils/icons";

export const Memberships = ({ userData, supabase, handleSnackbar }) => {
  const dispatch = useDispatch();
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [openCreatePopup, setOpenCreatePopup] = useState(false);
  const [category, setCategory] = useState({});
  const [categoryIndex, setCategoryIndex] = useState();
  const [apiKey, setApiKey] = useState(null);

  useEffect(() => {
    if (userData?.operators?.length > 0) {
      setApiKey(userData?.operators[0]?.api_key);
    }
  }, [userData]);

  useEffect(async () => {
    const { data, error } = await getOrgByEmail(userData?.email);

    if (data) {
      dispatch(updateUser(data));
    }

    if (error) {
      console.log(error);
      handleSnackbar(
        "Error fetching organization data. Please get in touch if it persists",
        "error"
      );
    }
  }, []);

  const handleOpenEditPopup = (category, index) => {
    setOpenEditPopup(true);
    setCategory(category);
    setCategoryIndex(index);
  };

  const handleOpenCreatePopup = () => {
    setOpenCreatePopup(true);
  };

  return (
    <div>
      <div style={{ height: "20px" }} />
      {openEditPopup && (
        <EditMembershipDialog
          openPopup={openEditPopup}
          setOpenPopup={setOpenEditPopup}
          userData={userData}
          category={category}
          categoryIndex={categoryIndex}
          apiKey={apiKey}
          supabase={supabase}
        />
      )}
      {openCreatePopup && (
        <CreateMembershipDialog
          openPopup={openCreatePopup}
          setOpenPopup={setOpenCreatePopup}
          apiKey={apiKey}
          userData={userData}
          supabase={supabase}
        />
      )}
      <div className="standard-container" style={{ marginBottom: "20px" }}>
        <h2>Organization Memberships</h2>
        <p id="subTitle" style={{ marginBottom: "20px" }}>
          Create memberships and offer special perks to your members.
        </p>
        <MainButton
          text={"Create new membership category"}
          color={COLORS.black}
          hoverColor={COLORS.black}
          textColor={COLORS.white}
          borderColor={COLORS.black}
          shadowColor={COLORS.mainAccent}
          textHoverColor={COLORS.lightGrey}
          onClickAction={() => handleOpenCreatePopup()}
          width={"fit-content"}
        >
          {ICONS.plus20}
        </MainButton>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {userData?.memberships_categories?.map((category, index) => (
          <div
            key={index}
            className="small-container"
            style={{
              height: "105px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ width: "100%" }}>
                <p
                  style={{
                    fontFamily: "DrukWideCy",
                    fontSize: "18px",
                  }}
                >
                  {category?.name}
                </p>
                <p id="subheader">
                  Price: {category?.price} {category?.currency}
                </p>
                <p id="subheader">
                  Sold: {category?.supply.sold} out of {category?.supply.total}
                </p>
              </div>
              <RiUserSettingsLine color={COLORS.mainAccent} />
            </div>
            <div className="container-row" style={{ marginTop: "15px" }}>
              <MainButton
                text={"Edit"}
                color={"transparent"}
                hoverColor={"transparent"}
                textColor={COLORS.black}
                borderColor={COLORS.black}
                shadowColor={COLORS.mainAccent}
                textHoverColor={COLORS.grey}
                onClickAction={() => handleOpenEditPopup(category, index)}
                width={"fit-content"}
              >
                {<AiOutlineEdit size={20} />}
              </MainButton>
            </div>
          </div>
        ))}
      </div>
      <div style={{ height: "20px" }} />
    </div>
  );
};
